
import { defineComponent } from 'vue';

// Lyra Function
import { lyraVueInitialise } from './core/modules/lyra/services';
import { versionsVueInitialise } from './core/modules/versions/services';
import { analyticsVueInitialise } from './core/modules/analytics/services';

export default defineComponent({
	setup () {
		return { ...lyraVueInitialise(), ...versionsVueInitialise(), ...analyticsVueInitialise() }
	},
})
